import {
  FirewallAdvancedSection,
  FirewallNetworkSection,
  FirewallSettingsSection,
} from '@nirvana/shared/dtos/types/policies/common';

// UI form value format
export interface FirewallSettingsFormValue {
  uiSettings: { firewall: { settings: FirewallSettingsSection } };
}

export interface FirewallNetworkFormValue {
  uiSettings: { firewall: { network: FirewallNetworkSection } };
}

export interface FirewallAdvancedFormValue {
  uiSettings: { firewall: { advanced: FirewallAdvancedSection } };
}

// advanced protocol options
export enum FirewallAdvancedRuleProtocolTypeForFrontend {
  ANY = 'any',
  TCP = 'tcp',
  UDP = 'udp',
  CUSTOM = 'custom',
}

// application path
export enum ApplicationPathType {
  SYSTEM = 'system',
  SYSTEM_2 = '%system%',
  ALL_USERS_PROFILE = '%ALLUSERSPROFILE%',
  APP_DATA = '%AppData%',
  LOCAL_APP_DATA = '%LOCALAPPDATA%',
  PROGRAM_FILES = '%ProgramFiles%',
  COMMON_PROGRAM_FILES = '%CommonProgramFiles%',
  COMMON_PROGRAM_FILES_X86 = '%COMMONPROGRAMFILES(X86)%',
  WIN_DIR = '%WinDir%',
  WIN_DIR_SYSTEM_32 = '%WINDIR%\\system32',
  TEMP = '%TEMP%',
  PROGRAM_FILES_X86 = '%PROGRAMFILES(X86)%',
}

// advanced permission
export enum FirewallAdvancedNetworkFrontend {
  HOME = 0,
  PUBLIC = 1,
}

// searchable keywords
export enum FirewallSettingsSearchableKeywords {
  Firewall = 'Firewall',
  Ics = 'Ics',
  MonitorWifi = 'MonitorWifi',
  Log = 'Log',
  BlockScan = 'BlockScan',
  Exclusions = 'Exclusions',
  Duplicate = 'Duplicate',
  Ids = 'Ids',
  Aggressive = 'Aggressive',
  Normal = 'Normal',
  Permissive = 'Permissive',
}

export enum FirewallNetworkSearchableKeywords {
  Settings = 'Settings',
  Networks = 'Networks',
  NetworkProfile = 'NetworkProfile',
  Mac = 'Mac',
  Ip = 'Ip',
  Adapters = 'Adapters',
  Wired = 'Wired',
  Wireless = 'Wireless',
  Virtual = 'Virtual',
}

export enum FirewallAdvancedSearchableKeywords {
  Rules = 'Rules',
  Settings = 'Settings',
  ProtectionLevel = 'ProtectionLevel',
  CreateAggressiveRules = 'CreateAggressiveRules',
  CreateRules = 'CreateRules',
  Monitor = 'Monitor',
  Ignore = 'Ignore',
}
